import { authState } from "@/app/state/authState";
import { completedState } from "@/app/state/completedState";
import { inboxState } from "@/app/state/inboxState";

export namespace state {
  export const auth = authState.auth;
  export const inboxFilter = inboxState.inboxFilter;
  export const completedFilter = completedState.completedFilter;
}
